import { createUseStyles } from "react-jss";
export default createUseStyles((theme) => ({
    container: {
        width: '100%',
        borderRadius: 5,
        border: `1px solid ${theme.palette.grey[8]}`,
        resize: 'none',
        height: 110,
        padding: 10,
        '&:focus': {
            outline: 'none'
        },
        '&::placeholder': {
            fontSize: 15,
            color: theme.palette.grey[8]
        }
    }
}));
//# sourceMappingURL=styles.js.map